import {observable} from 'mobx';
import {createInstance, ModelProperties} from 'utils';

import {Language} from './language';
import {WebLocaleCategory} from './web-locale-category';

export class WebPageSync {
    @observable id!: number;

    @observable synced!: boolean;

    @observable categoryId!: number;

    @observable languageId!: number;

    @observable category?: WebLocaleCategory;

    @observable language?: Language;

    constructor(status?: ModelProperties<WebPageSync>) {
        if (status) {
            Object.assign(this, status);
            this.language = createInstance(Language, status.language);
            this.category = createInstance(WebLocaleCategory, status.category);
        }
    }
}